export default __webpack_public_path__ + "static/media/ba3.7952f810.jpg";